import { RemoteGetAllPersonsFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesPersons } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonsFromEntity =
  (): RemoteGetAllPersonsFromEntity => {
    return new RemoteGetAllPersonsFromEntity(
      makeApiUrlEntitiesPersons(),
      makeAxiosHttpClient(),
    );
  };
